// extracted by mini-css-extract-plugin
export default {"button":"XeJTUu","sliderContainer":"HCMXU_"};